// extracted by mini-css-extract-plugin
export var equalColumn = "_fm-0";